import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showAppLoader } from '../../../../../../redux/actions/app';

import {
  useStripe,
  useElements,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from '@stripe/react-stripe-js';
import Spinner from 'web/components/Spinner';
import AlertModal from 'web/components/AlertModal';
import './debitForm.scss';
import '../../payment.scss';
const useOptions = () => {
  const fontSize = '16px';
  const options = useMemo(
    () => ({
      style: {
        base: {
          fontSize,
          color: '#424770',
          letterSpacing: '0.025em',
          fontFamily: 'Source Code Pro, monospace',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#9e2146',
        },
      },
    }),
    [fontSize]
  );

  return options;
};

const DebitForm = () => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [cardName, setCardName] = useState('');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );

  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();

  let cardBrandToPfClass = {
    visa: 'pf-visa',
    mastercard: 'pf-mastercard',
    amex: 'pf-american-express',
    discover: 'pf-discover',
    diners: 'pf-diners',
    jcb: 'pf-jcb',
    unknown: 'pf-credit-card',
  };

  const setBrandIcon = (brand) => {
    let brandIconElement = document.getElementById('brand-icon');
    let pfClass = 'pf-credit-card';
    if (brand in cardBrandToPfClass) {
      pfClass = cardBrandToPfClass[brand];
    }
    for (let i = brandIconElement.classList.length - 1; i >= 0; i--) {
      brandIconElement.classList.remove(brandIconElement.classList[i]);
    }
    brandIconElement.classList.add('pf');
    brandIconElement.classList.add(pfClass);
  };

  let resultResponse = useSelector((state) => state.buyerSeller);

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch(showAppLoader())
    if (!stripe || !elements) {
      return;
    }

    //Debit Card
    const card = elements.getElement(CardNumberElement);
  };
  const handleChange = (event) => {
    setCardName(event.target.value);
  }
  return (
    <div className='paymentWrapper'>
      {loaderVisible && <Spinner />}
      <div className='payment'>
        <div>
          <form onSubmit={handleSubmit}>
            <label>
              Name on Card
              <input
                name='cardName'
                className='stripeInput'
                placeholder='Name on Card'
                value={cardName}
                onChange={(event) => handleChange(event)}
              />
            </label>
            <label>
              Card number
              <CardNumberElement
                options={options}
                onReady={() => {
                }}
                onChange={(event) => {
                  // Switch brand logo
                  if (event.brand) {
                    setBrandIcon(event.brand);
                  }
                }}
                onBlur={() => {
                }}
                onFocus={() => {
                }}
              />
            </label>

            <label>
              Expiration date
              <CardExpiryElement
                options={options}
                onReady={() => {
                }}
                onChange={(event) => {
                }}
                onBlur={() => {
                }}
                onFocus={() => {
                }}
              />
            </label>
            <label>
              CVC
              <CardCvcElement
                options={options}
                onReady={() => {
                }}
                onChange={(event) => {
                }}
                onBlur={() => {
                }}
                onFocus={() => {
                }}
              />
            </label>
            <button
              type='submit'
              className='app-green-button'
              disabled={!stripe}>
              Submit
            </button>
          </form>
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={title}
            content=''
            link=''
          />
        </div>
      </div>
    </div>
  );
};

export default DebitForm;
